import React, {Component} from 'react';
import SimpleReactValidator from 'simple-react-validator';

// فارسی سازی شده برای هوطنان عزیز - علیرضا عزیزی
const fa = {
    accepted: ':attribute باید پذیرفته شود.',
    after: ':attribute باید بزرگتر از :date باشد.',
    after_or_equal: ':attribute باید بزرگتر یا برابر :date باشد.',
    alpha: ':attribute می بایست تنها شامل حروف باشد.',
    alpha_space: ':attribute می بایست تنها شامل حروف و Space باشد.',
    alpha_num: ':attribute می بایست شامل حرف و اعداد باشد.',
    alpha_num_space: ':attribute می بایست شامل حروف، اعداد و Space باشد.',
    alpha_num_dash: ':attribute می بایست شامل حروف، اعداد و Dash(-) باشد.',
    alpha_num_dash_space: ':attribute می بایست شامل حروف، اعداد، Space و Dash(-) باشد.',
    array: ':attribute می باست آرایه باشد.',
    before: ':attribute باید کوچکتر از :date باشد.',
    before_or_equal: ':attribute باید کوچکتر یا برابر :date باشد.',
    between: ':attribute باید بین :min و :max:type باشد.',
    boolean: ':attribute باید از نوع boolean باشد.',
    card_exp: ':attribute باید شامل بک تاریخ پایان معتبر باشد.',
    card_num: ':attribute فرمت شماره کارت اعتباری صحیح نمی باشد.',
    currency: ':attribute فرمت مبلغ صحیح نمی باشد.',
    date: ':attribute فرمت تاریخ صحیح نمی باشد.',
    date_equals: ':attribute می بایست با :date برابر باشد.',
    email: ':attribute فرمت ایمیل صحیح نمی باشد.',
    in: ':attribute انتخاب شده می بایست در :values باشد.',
    integer: ':attribute باید از اعداد باشد.',
    max: 'حداقل کاراکتر های :attribute، :max حرف می باشد.',
    min: 'حداقل کاراکتر های :attribute، :min حرف می باشد.',
    not_in: ':attribute نباید در  :values باشد.',
    not_regex: ':attribute فرمت الگو مورد نظر صحیح نمی باشد.',
    numeric: ':attribute فرمت عدد صحیح نمی باشد.',
    phone: ':attribute فرمت تلفن صحیح نمی باشد.',
    regex: ':attribute فرمت الگو مورد نظر صحیح نمی باشد.',
    required: ':attribute اجباری می باشد.',
    size: 'تعداد حروف معتبر :attribute ، :size حرف می باشد.',
    string: ':attribute فرمت رشته صحیح نمی باشد.',
    typeof: ':attribute در نوع :type صحیح نمی باشد.',
    url: ':attribute فرمت آدرس تارنما صحیح نمی باشد.',
}

const Validator = () => {
    SimpleReactValidator.addLocale('fa', fa);

    return new SimpleReactValidator({
        locale: 'fa', className: 'validatorText',
        validators: {
            mobile: {  // name the rule
                message: 'فرمت موبایل وارد شده صحیح نمی باشد.',
                rule: (val, params, validator) => {
                    return validator.helpers.testRegex(val, /^[0]?[789]\d{9}$/) && params.indexOf(val) === -1
                },
                messageReplace: (message, params) => message.replace(':values', this.helpers.toSentence(params)),  // optional
                required: true  // optional
            },
            persianChars: {  // name the rule
                message: ':attribute می بایست تنها شامل حروف الفبا فارسی باشد.',
                rule: (val, params, validator) => {
                    return validator.helpers.testRegex(val, /[\u0600-\u06ff]|[\u0750-\u077f]|[\ufb50-\ufc3f]|[\ufe70-\ufefc]/) && params.indexOf(val) === -1
                },
                messageReplace: (message, params) => message.replace(':values', this.helpers.toSentence(params)),  // optional
                required: true  // optional
            },
            confirmPassword: {  // name the rule
                message: 'تاییدیه کلمه عبور با کلمه عبور مطابقت ندارد.',
                rule: (val, params, validator) => {
                    return val === params[0]
                },
                required: true  // optional
            }
        }
    });
}

export default Validator;


// WEBPACK FOOTER //
// ./components/Validator/index.js